(function () {
      var quizzes = Array.prototype.slice.call(document.querySelectorAll('[data-grova-quiz]'));
      if (!quizzes.length) return;

      quizzes.forEach(function (quiz) {
      var REDIRECT_URL = quiz.getAttribute('data-redirect-url') || '/products/total-wellness-mushroom-gummies';
      var TRACKING_URL = 'https://script.google.com/macros/s/AKfycbwKLe3yvp5OfEIZsjIFV-gQ9rwg4ITBDR7Bom-jrxt_CeOpDDSqcE2NaBCYHKTYGeyL/exec';

      var steps = Array.prototype.slice.call(quiz.querySelectorAll('.gq-step'));
      var nextButtons = Array.prototype.slice.call(quiz.querySelectorAll('.gq-next'));
      var options = Array.prototype.slice.call(quiz.querySelectorAll('.gq-option'));

      var progressWrap = quiz.querySelector('[data-gq-progress-wrap]');
      var progressBar = quiz.querySelector('[data-gq-progress-bar]');
      var progressText = quiz.querySelector('[data-gq-progress-text]');
      var progressPercent = quiz.querySelector('[data-gq-progress-percent]');

      var currentStep = 0;
      var answers = {};
      var autoTimer = null;
      var autoInterval = null;
      var buildTimers = [];
      var discountTimers = [];
      var hasTrackedCompletion = false;
      var submissionId = 'gq-' + Date.now() + '-' + Math.random().toString(36).slice(2, 10);

      function forceProgress(progress) {
        progress = Math.max(0, Math.min(100, progress));
        var scale = progress / 100;

        if (progressBar) {
          progressBar.style.setProperty('transform', 'scaleX(' + scale + ')', 'important');
          progressBar.style.setProperty('width', '100%', 'important');
          progressBar.style.setProperty('background', '#006b36', 'important');
          progressBar.style.setProperty('display', 'block', 'important');
        }

        if (progressPercent) {
          progressPercent.textContent = progress + '%';
        }
      }

      function updateProgress() {
        var activeStep = steps[currentStep];
        var type = activeStep.getAttribute('data-type');
        var questionNumber = activeStep.getAttribute('data-question');
        var progress = parseInt(activeStep.getAttribute('data-progress') || '0', 10);
        var hideProgress = activeStep.getAttribute('data-hide-progress') === 'true';

        if (progressWrap) {
          progressWrap.style.display = currentStep === 0 || hideProgress ? 'none' : 'block';
        }

        forceProgress(progress);

        if (progressText) {
          if (type === 'question' && questionNumber) {
            progressText.textContent = 'Question ' + questionNumber;
          } else if (type === 'results' || type === 'product') {
            progressText.textContent = 'Results';
          } else if (type === 'discount') {
            progressText.textContent = 'Applying discount';
          } else if (type === 'build') {
            progressText.textContent = 'Building profile';
          } else if (type === 'loading') {
            progressText.textContent = 'Analysing profile';
          } else {
            progressText.textContent = 'Assessment';
          }
        }
      }

      function resetAutoTimers() {
        if (autoTimer) {
          clearTimeout(autoTimer);
          autoTimer = null;
        }

        if (autoInterval) {
          clearInterval(autoInterval);
          autoInterval = null;
        }

        buildTimers.forEach(function (timer) {
          clearTimeout(timer);
        });
        buildTimers = [];

        discountTimers.forEach(function (timer) {
          clearTimeout(timer);
        });
        discountTimers = [];
      }

      function runAutoLoading(step) {
        var ring = step.querySelector('.gq-loader-ring');
        var percentText = step.querySelector('.gq-loader-percent');
        var duration = parseInt(step.getAttribute('data-duration') || '4200', 10);
        var start = Date.now();

        if (!ring || !percentText) return;

        ring.style.setProperty('--loader-progress', '0%');
        percentText.textContent = '0%';

        autoInterval = setInterval(function () {
          var elapsed = Date.now() - start;
          var progress = Math.min(100, Math.round((elapsed / duration) * 100));

          ring.style.setProperty('--loader-progress', progress + '%');
          percentText.textContent = progress + '%';

          if (progress >= 100) {
            clearInterval(autoInterval);
            autoInterval = null;
          }
        }, 30);

        autoTimer = setTimeout(function () {
          resetAutoTimers();
          nextStep();
        }, duration + 250);
      }

      function runBuildLoading(step) {
        var items = Array.prototype.slice.call(step.querySelectorAll('.gq-build-item'));

        items.forEach(function (item) {
          item.classList.remove('active');
          item.classList.remove('done');
        });

        items.forEach(function (item, index) {
          var activeTimer = setTimeout(function () {
            item.classList.add('active');
          }, index * 1350);

          var doneTimer = setTimeout(function () {
            item.classList.remove('active');
            item.classList.add('done');
          }, index * 1350 + 820);

          buildTimers.push(activeTimer, doneTimer);
        });

        var nextTimer = setTimeout(function () {
          resetAutoTimers();
          nextStep();
        }, items.length * 1350 + 1100);

        buildTimers.push(nextTimer);
      }

      function getTrackingPayload(status, questionName, questionValue) {
        var params = new URLSearchParams(window.location.search);

        return {
          timestamp: new Date().toISOString(),
          submission_id: submissionId,
          submission_status: status,
          last_question: questionName || '',
          last_answer: questionValue || '',
          answered_count: Object.keys(answers).length,
          page_url: window.location.href,
          redirect_url: REDIRECT_URL,
          quiz_name: 'Men - High Cortisol Quiz',
          age: answers.age || '',
          face_stomach: answers.face_stomach || '',
          night_waking: answers.night_waking || '',
          energy_3pm: answers.energy_3pm || '',
          brain_fog: answers.brain_fog || '',
          drive: answers.drive || '',
          timeline: answers.timeline || '',
          utm_source: params.get('utm_source') || '',
          utm_medium: params.get('utm_medium') || '',
          utm_campaign: params.get('utm_campaign') || '',
          utm_content: params.get('utm_content') || '',
          utm_term: params.get('utm_term') || '',
          answers_json: JSON.stringify(answers)
        };
      }

      function sendTrackingPayload(payload) {
        var body = new URLSearchParams();

        Object.keys(payload).forEach(function (key) {
          body.append(key, payload[key]);
        });

        if (navigator.sendBeacon) {
          var blob = new Blob([body.toString()], { type: 'application/x-www-form-urlencoded;charset=UTF-8' });
          if (navigator.sendBeacon(TRACKING_URL, blob)) return;
        }

        fetch(TRACKING_URL, {
          method: 'POST',
          mode: 'no-cors',
          keepalive: true,
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
          },
          body: body.toString()
        }).catch(function () {});
      }

      function trackPartialSubmission(questionName, questionValue) {
        sendTrackingPayload(getTrackingPayload('partial', questionName, questionValue));
      }

      function trackQuizCompletion() {
        if (hasTrackedCompletion) return;
        hasTrackedCompletion = true;

        sendTrackingPayload(getTrackingPayload('completed'));
      }

      function runDiscountLoading(step) {
        var items = Array.prototype.slice.call(step.querySelectorAll('.gq-discount-item'));
        trackQuizCompletion();

        items.forEach(function (item) {
          item.classList.remove('active');
          item.classList.remove('done');
        });

        items.forEach(function (item, index) {
          var activeTimer = setTimeout(function () {
            item.classList.add('active');
          }, index * 750);

          var doneTimer = setTimeout(function () {
            item.classList.remove('active');
            item.classList.add('done');
          }, index * 750 + 450);

          discountTimers.push(activeTimer, doneTimer);
        });

        var redirectTimer = setTimeout(function () {
          window.location.href = REDIRECT_URL;
        }, items.length * 750 + 950);

        discountTimers.push(redirectTimer);
      }

      function showStep(index) {
        resetAutoTimers();

        steps.forEach(function (step) {
          step.classList.remove('active');
        });

        currentStep = Math.max(0, Math.min(index, steps.length - 1));
        steps[currentStep].classList.add('active');

        updateProgress();

        var motionSafe = !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        window.scrollTo({
          top: quiz.offsetTop,
          behavior: motionSafe ? 'smooth' : 'auto'
        });

        if (steps[currentStep].getAttribute('data-auto') === 'true') {
          runAutoLoading(steps[currentStep]);
        }

        if (steps[currentStep].getAttribute('data-build-auto') === 'true') {
          runBuildLoading(steps[currentStep]);
        }

        if (steps[currentStep].getAttribute('data-discount-auto') === 'true') {
          runDiscountLoading(steps[currentStep]);
        }
      }

      function nextStep() {
        showStep(currentStep + 1);
      }

      options.forEach(function (button) {
        button.addEventListener('click', function () {
          var name = button.getAttribute('data-name');
          var value = button.getAttribute('data-value');

          if (name) {
            answers[name] = value;
            trackPartialSubmission(name, value);
          }

          nextStep();
        });
      });

      nextButtons.forEach(function (button) {
        button.addEventListener('click', nextStep);
      });

      updateProgress();
      });
    })();
